import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import i18n from 'i18next';
import config from 'utils/config';
import api from 'utils/api';
import { fetchMindsetAgent } from 'actions/userProfile/useFetchMindsetAgent';
// ID of the container where the Mindset SDK will be rendered
export var MINDSET_ID = 'mindset-container';
function renderMindsetAi(_x, _x2, _x3) {
  return _renderMindsetAi.apply(this, arguments);
}
function _renderMindsetAi() {
  _renderMindsetAi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(appUid, agentUid, search) {
    var _yield$api, authToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return api('get', '/api/mindset/authToken');
        case 2:
          _yield$api = _context.sent;
          authToken = _yield$api.authToken;
          window.mindset.initApp({
            containerId: MINDSET_ID,
            appUid: appUid,
            authToken: authToken,
            loadingText: i18n.t('loading')
          });

          // Initiate the Mindset SDK
          window.mindset.startAgentThread({
            /* 
            agentUid
            - Required
            */
            agentUid: agentUid,
            /* 
            initialQuestion
            - optional
            - If this is missing or an empty string then the configured icebreaker message, if any, will be used to start an agent conversation.
            - If this is supplied then it will be sent to the agent as the first input from the user. */
            initialQuestion: search
            /*
            variables
            - optional
            - e.g. { role: 'supervisor', customerId: 'bigcorp' }
            - Some content can be ingested so that it will link to external URLs. It is possible that these URLs will contain placeholders that need to be replaced with specific values for individual users.
            -This parameter allows you to specify those values at the moment the user interacts with the agent.
            */
            // variables: { role: 'supervisor', customerId: 'bigcorp' },
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _renderMindsetAi.apply(this, arguments);
}
export function addMindsetAIIfRequired() {
  return _addMindsetAIIfRequired.apply(this, arguments);
}
function _addMindsetAIIfRequired() {
  _addMindsetAIIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _ref,
      _ref$render,
      render,
      search,
      appUid,
      _yield$fetchMindsetAg,
      agentUid,
      _firstScript$parentNo,
      newScript,
      firstScript,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _ref = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref$render = _ref.render, render = _ref$render === void 0 ? false : _ref$render, search = _ref.search;
          appUid = config.mindsetAppUid;
          if (appUid) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return");
        case 4:
          _context2.next = 6;
          return fetchMindsetAgent();
        case 6:
          _yield$fetchMindsetAg = _context2.sent;
          agentUid = _yield$fetchMindsetAg.agentUid;
          if (agentUid) {
            _context2.next = 10;
            break;
          }
          return _context2.abrupt("return");
        case 10:
          if (document.getElementById('mindsetAIScript')) {
            _context2.next = 21;
            break;
          }
          newScript = document.createElement('script');
          newScript.type = 'text/javascript';
          newScript.async = true;
          newScript.src = "https://".concat(appUid, ".mindset.ai/mindset-sdk.js");
          newScript.id = 'mindsetAIScript';
          if (render) {
            newScript.addEventListener('load', function () {
              renderMindsetAi(appUid, agentUid);
            });
          }
          firstScript = document.getElementsByTagName('script')[0];
          (_firstScript$parentNo = firstScript.parentNode) === null || _firstScript$parentNo === void 0 ? void 0 : _firstScript$parentNo.insertBefore(newScript, firstScript);
          _context2.next = 24;
          break;
        case 21:
          if (!render) {
            _context2.next = 24;
            break;
          }
          _context2.next = 24;
          return renderMindsetAi(appUid, agentUid, search);
        case 24:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _addMindsetAIIfRequired.apply(this, arguments);
}